import { render, staticRenderFns } from "./addButton.vue?vue&type=template&id=08abf63a&scoped=true&"
import script from "./addButton.vue?vue&type=script&lang=js&"
export * from "./addButton.vue?vue&type=script&lang=js&"
import style0 from "./addButton.vue?vue&type=style&index=0&id=08abf63a&scoped=true&sass=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08abf63a",
  null
  
)

export default component.exports